import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<
	| 'createSkillHeaderLabel'
	| 'updateSkillHeaderLabel'
	| 'skillNameLabel'
	| 'descriptionLabel'
	| 'instructionsLabel'
	| 'showMoreLabel'
	| 'showLessLabel'
	| 'expandLabel'
	| 'collapseLabel'
	| 'cancelLabel'
	| 'updateLabel'
	| 'confirmLabel'
	| 'editLabel'
	| 'loadingDetailsLabel',
	MessageDescriptor
> = defineMessages({
	createSkillHeaderLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.createSkillHeaderLabel',
		defaultMessage: 'Create skill',
		description: 'Card header title for the create custom skill action card.',
	},
	updateSkillHeaderLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.updateSkillHeaderLabel',
		defaultMessage: 'Update skill',
		description: 'Card header title for the update custom skill action card.',
	},
	skillNameLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.skillNameLabel',
		defaultMessage: 'Skill name',
		description: 'Section label for the skill name field inside the card body.',
	},
	descriptionLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.descriptionLabel',
		defaultMessage: 'Description',
		description: 'Section label for the skill description field inside the card body.',
	},
	instructionsLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.instructionsLabel',
		defaultMessage: 'Instructions',
		description: 'Section label for the skill instructions field inside the card body.',
	},
	showMoreLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.showMoreLabel',
		defaultMessage: 'Show more',
		description: 'Button label that reveals the full truncated text in the card body.',
	},
	showLessLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.showLessLabel',
		defaultMessage: 'Show less',
		description: 'Button label that collapses the full text in the card body.',
	},
	expandLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.expandLabel',
		defaultMessage: 'Expand',
		description: 'Accessible label for the chevron button that expands the card.',
	},
	collapseLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.collapseLabel',
		defaultMessage: 'Collapse',
		description: 'Accessible label for the chevron button that collapses the card.',
	},
	cancelLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.cancelLabel',
		defaultMessage: 'Cancel',
		description: 'Footer button that cancels the custom skill action.',
	},
	updateLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.updateLabel',
		defaultMessage: 'Update',
		description: 'Footer button that confirms skill update.',
	},
	confirmLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.confirmLabel',
		defaultMessage: 'Confirm',
		description: 'Footer button that confirms skill creation.',
	},
	editLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.editLabel',
		defaultMessage: 'Edit',
		description: 'Footer button that opens the edit skill modal.',
	},
	loadingDetailsLabel: {
		id: 'conversation-assistant-message-actions.controllers.studio-custom-skill.loadingDetailsLabel',
		defaultMessage: 'Loading skill details',
		description:
			'Accessible label for the spinner shown next to the card title while the latest skill details load.',
	},
});
